<template>
	<div class="align-self-center">
		<v-btn v-for="info in contactInfo" :key="info[1]" v-external flat icon color="blue" class="mx-3" :href="info[1]">
			<v-icon :color="color">{{ info[0] }}</v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '#fff',
		},
	},

	data: () => ({
		contactInfo: [
			[ 'call',         'tel:1-973-839-0737' ],
			[ 'mail_outline', 'mailto:allstarkidsnj@gmail.com' ],
			[ 'location_on',  'https://www.google.com/maps/place/21+Greenwood+Lake+Turnpike,+Ringwood,+NJ+07456/@41.0728352,-74.2837123,17z/data=!3m1!4b1!4m5!3m4!1s0x89c31c275bd7ef25:0x74cbcfb9f27fac78!8m2!3d41.0728312!4d-74.2815236' ],
		],
	}),
}
</script>
